import * as React from 'react';
import { observer } from 'mobx-react';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { messageStackState } from "/@/app/states/messageStackState";
import {useTheme} from "@mui/material";

//
// A stack of pop-up messages.
// Based on a global state, by MobX.
//
// Showing one below another is considered a bad approach, so they overlap.
// - TODO make it show the last message, inc. when it's added
// - TODO apply "tags" like error/warning/success/etc.
//

export const MessageStack = observer(() => {
    const theme = useTheme();
    const state = messageStackState;

    const handleClose = (event, reason) => {
        state.nextMessage();
    };

    let text = "";
    if (state.messageShown) {
        text = (state.messageShown.text || "").slice(0, 400);  // XXX magic limit, based on some real messages
        if (text.length < state.messageShown.text.length) {
            text += '...';
        }
        if (state.messageShown.content) {
            text = state.messageShown.content;
        }
    }


    return (
        <>
            {state.messageShown !== null ? (
                <Snackbar
                    open={Boolean(state.messageShown)}
                    autoHideDuration={state.messageShown.autoHide}
                    onClose={state.messageShown.autoHide ? handleClose : () => {} }
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                    message={text}
                    action={
                        <React.Fragment>
                            <IconButton
                                aria-label="close"
                                color="inherit"
                                sx={{ p: 0.5 }}
                                onClick={handleClose}
                            >
                                <CloseIcon />
                            </IconButton>
                        </React.Fragment>
                    }
                    sx={{
                        "& .MuiSnackbarContent-message": {
                            flexGrow: "1",
                            textAlign: 'center',
                        },
                        // Take BG color from theme
                        "& .MuiPaper-root": {
                            backgroundColor: {
                                info: theme.palette.info.main,
                                warning: theme.palette.warning.main,
                                success: theme.palette.success.main,
                                error: theme.palette.error.main,
                            }[state.messageShown.tags]
                        }
                    }}
                />
            ) : null}
        </>
    );
});
